module.exports = __webpack_public_path__ + "static/avatar-eb77b28ba99bf03303cc919d6eafb4df.png";